import { useStore } from 'src/contexts/StoreContext';
import { ARROW_POSITIONS } from './Tutorial.types';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

export const useTutorialLogic = () => {
  const {
    tutorial: {
      activeStep,
      onNextHandler,
      isTutorialOn,
      tutorialVisible,
      updateTutorial,
      firstProductArea,
      toolbarArea,
      toolbarAreaMobile,
      sliderZoomArea,
      withBackground,
    },
  } = useStore();

  const { isDesktop } = useResponsiveScreen();

  let targetArea = toolbarArea;
  let tutorialCardPosition = {
    x: 0,
    y: 0,
  };
  const tooltipWidth = 348;
  const tooltipHeight = 120;
  switch (activeStep.targetArea) {
    case 'firstProductArea':
      targetArea = firstProductArea;
      tutorialCardPosition = {
        x: isDesktop ? targetArea.x + targetArea.width + 200 : 10,
        y: isDesktop ? targetArea.y - 50 : targetArea.y - 40 - tooltipHeight,
      };
      break;
    case 'toolbarArea':
      targetArea = toolbarArea;
      tutorialCardPosition = {
        x: isDesktop ? targetArea.x + targetArea.width + 200 : 10,
        y: isDesktop ? targetArea.y - 50 : targetArea.y - 40 - tooltipHeight,
      };
      break;
    case 'toolbarAreaMobile':
      targetArea = toolbarAreaMobile;
      tutorialCardPosition = {
        x: isDesktop ? targetArea.x + targetArea.width + 200 : 10,
        y: isDesktop ? targetArea.y - 50 : targetArea.y - 40 - tooltipHeight,
      };
      break;
    case 'sliderZoomArea':
      targetArea = sliderZoomArea;
      tutorialCardPosition = {
        x: isDesktop ? targetArea.x + targetArea.width + 200 : 10,
        y: isDesktop ? targetArea.y - 50 : targetArea.y - tooltipHeight,
      };
      break;
  }

  const tutorialCard = { ...activeStep.tutorialCard, ...tutorialCardPosition };
  const arrow = activeStep.arrow;

  const tooltipPosition = { x: tutorialCard.x, y: tutorialCard.y };

  const tooltipCenterX = tooltipPosition.x + tooltipWidth / 2;
  const tooltipCenterY = tooltipPosition.y + tooltipHeight / 2;
  const targetCenterX = targetArea.x + targetArea.width / 2;
  const targetCenterY = targetArea.y + targetArea.height / 2;

  const goToNextStep = () => {
    /*  if (activeStepIndex !== steps.length - 1) setActiveStepIndex(activeStepIndex + 1);
    else closeTutorial(); */
    //onPressNext();
    onNextHandler(activeStep.onPressNext);
  };

  const getTooltipEdgePoint = (side: ARROW_POSITIONS) => {
    const offset = arrow.startOffset;
    switch (side) {
      case 'top':
        return { x: tooltipCenterX, y: tooltipPosition.y - offset };
      case 'bottom':
        return { x: tooltipCenterX, y: tooltipPosition.y + tooltipHeight + offset };
      case 'left':
        return { x: tooltipPosition.x - offset, y: tooltipCenterY };
      case 'right':
        return { x: tooltipPosition.x + tooltipWidth + offset, y: tooltipCenterY };
      default:
        return { x: 0, y: 0 };
    }
  };

  const getTargetEdgePoint = (side: ARROW_POSITIONS) => {
    const offset = arrow.endOffset;
    switch (side) {
      case 'top':
        return { x: targetCenterX, y: targetArea.y - offset };
      case 'bottom':
        return { x: targetCenterX, y: targetArea.y + targetArea.height + offset };
      case 'left':
        return { x: targetArea.x - offset, y: targetCenterY };
      case 'right':
        return { x: targetArea.x + targetArea.width + offset, y: targetCenterY };
      default:
        return { x: 0, y: 0 };
    }
  };

  let arrowStartX, arrowStartY, arrowEndX, arrowEndY;

  const startPoint = getTooltipEdgePoint(arrow.startSide);
  arrowStartX = startPoint.x;
  arrowStartY = startPoint.y;

  const endPoint = getTargetEdgePoint(arrow.endSide);
  arrowEndX = endPoint.x;
  arrowEndY = endPoint.y;

  return {
    targetArea, //: steps[activeStepIndex]?.targetArea,
    tutorialCard, //: steps[activeStepIndex]?.tutorialCard,
    arrow, //: steps[activeStepIndex]?.arrow,
    arrowStartX,
    arrowStartY,
    arrowEndX,
    arrowEndY,
    goToNextStep,
    isTutorialOn,
    tutorialVisible,
    updateTutorial,
    withBackground,
  };
};
